import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { SystemSetting } from '../shared/models/general/system-setting';
import { TransactionStatus } from '../shared/models/transactions/transaction-status';

@Injectable({
  providedIn: 'root',
})
export class SystemService {
  env = environment;
  apiUrl = this.env.apiurl + 'system/settings/';

  private pollUntilAuthorised$?: Observable<boolean>;

  constructor(
    private http: HttpClient,
    public router: Router
  ) {}

  public GetSystemSetting(module: string, setting: string): Observable<SystemSetting> {
    return this.http.get<SystemSetting>(`${this.apiUrl}${module}/${setting}`);
  }

  public UpdateSystemSetting(systemSetting: SystemSetting): Observable<SystemSetting> {
    return this.http.put<SystemSetting>(this.apiUrl, systemSetting);
  }

  loadPollUntilAuthorised(): Observable<boolean> {
    if (!this.pollUntilAuthorised$) {
      this.pollUntilAuthorised$ = this.http
        .get<{ enabled?: boolean; Enabled?: boolean }>(
          `${this.env.apiurl}system/feature-flags/PollUntilDealAuthorised`
        )
        .pipe(
          map((flag) => !!(flag?.enabled ?? flag?.Enabled)),
          catchError(() => of(false)),
          tap((enabled) => TransactionStatus.setPollUntilAuthorised(enabled)),
          shareReplay(1)
        );
    }

    return this.pollUntilAuthorised$;
  }
}
